import { FC } from "react";
import { IconPropsType } from ".";

export const Aboutus: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill={props.color}
      />
      <path
        d="M12.1084 6.97168V10.9707C12.1084 11.1803 12.1038 11.3854 12.0947 11.5859C12.0902 11.7865 12.0811 11.9893 12.0674 12.1943C12.0537 12.3994 12.0355 12.609 12.0127 12.8232C11.9945 13.0329 11.9717 13.2585 11.9443 13.5H11.0967C11.0648 13.2585 11.0374 13.0329 11.0146 12.8232C10.9964 12.609 10.9805 12.3994 10.9668 12.1943C10.9531 11.9893 10.9417 11.7865 10.9326 11.5859C10.9281 11.3854 10.9258 11.1803 10.9258 10.9707V6.97168H12.1084ZM10.625 16.2275C10.625 16.109 10.6455 15.9974 10.6865 15.8926C10.7321 15.7832 10.7936 15.6898 10.8711 15.6123C10.9486 15.5303 11.0397 15.4665 11.1445 15.4209C11.2539 15.3708 11.3701 15.3457 11.4932 15.3457C11.6162 15.3457 11.7301 15.3708 11.835 15.4209C11.9443 15.4665 12.0378 15.5303 12.1152 15.6123C12.1973 15.6898 12.2588 15.7832 12.2998 15.8926C12.3454 15.9974 12.3682 16.109 12.3682 16.2275C12.3682 16.3551 12.3454 16.4714 12.2998 16.5762C12.2588 16.681 12.1973 16.7744 12.1152 16.8564C12.0378 16.9339 11.9443 16.9932 11.835 17.0342C11.7301 17.0798 11.6162 17.1025 11.4932 17.1025C11.3701 17.1025 11.2539 17.0798 11.1445 17.0342C11.0397 16.9932 10.9486 16.9339 10.8711 16.8564C10.7936 16.7744 10.7321 16.681 10.6865 16.5762C10.6455 16.4714 10.625 16.3551 10.625 16.2275Z"
        fill={props.color}
      />
    </svg>
  );
};
